module.exports = __webpack_public_path__ + "static/media/camera.326c85ed.svg";